import { withNamespaces } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {
    Card,
    CardBody,
    Row,
} from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';

import useMailboxBackPath from '../../hooks/useMailboxBackPath';
import MailboxBackButton from '../mailbox-back-button';
import ComposeActions from './components/ComposeActions';
import ComposeFields from './components/ComposeFields';
import ComposeOriginalMessage from './components/ComposeOriginalMessage';
import useComposeMessage from './hooks/useComposeMessage';

const Compose = ({
    t,
}) => {
    const location = useLocation();
    const reply = location.state?.mailboxReply || null;
    const {
        backPath,
        backFolderTitleKey,
        goBack,
    } = useMailboxBackPath();
    const {
        handleSubmit,
        handleDiscard,
        isSending,
    } = useComposeMessage({
        t,
        discardPath: backPath,
        inReplyTo: reply?.inReplyTo,
        original: reply?.original,
    });

    return (
        <Card>
            <CardBody>
                <MailboxBackButton
                    folderTitleKey={backFolderTitleKey}
                    onClick={goBack}
                />

                <h5 className="mailbox-compose__title mb-3">
                    {t(reply ? 'Reply' : 'Compose')}
                </h5>

                <AvForm
                    key={reply?.inReplyTo || 'compose'}
                    className="needs-validation"
                    model={{
                        to: reply?.to || '',
                        cc: reply?.cc || '',
                        subject: reply?.subject || '',
                        body: reply?.body || '',
                    }}
                    onValidSubmit={handleSubmit}
                >
                    <Row>
                        <ComposeFields isReply={Boolean(reply)} />
                        {reply?.original ? (
                            <ComposeOriginalMessage original={reply.original} />
                        ) : null}
                        <ComposeActions
                            isSending={isSending}
                            onDiscard={handleDiscard}
                        />
                    </Row>
                </AvForm>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(Compose);
